import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';

function PartsListCard({ parts }) {
  const { t } = useTranslation();

  if (!parts || parts.length === 0) return null;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR' }).format(price);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.colors.surface,
        borderRadius: theme.radius.xl,
        padding: '20px',
        boxShadow: theme.shadows.md,
        marginBottom: '20px',
      }}
    >
      <Typography
        component="h3"
        sx={{
          fontSize: '16px',
          fontWeight: '700',
          margin: '0 0 16px 0',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <SettingsIcon sx={{ color: theme.colors.accent, fontSize: 20 }} />
        {t('public_maintenance.parts')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {parts.map((part) => (
          <Box
            key={part.id}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px',
              backgroundColor: theme.colors.background,
              borderRadius: theme.radius.md,
            }}
          >
            <Box>
              <Typography sx={{ fontSize: '14px', fontWeight: '500' }}>
                {part.name}
              </Typography>
              {part.description && (
                <Typography sx={{ fontSize: '12px', color: theme.colors.textMuted }}>
                  {part.description}
                </Typography>
              )}
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              {parseFloat(part.discount_percent || 0) > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px' }}>
                  <Typography sx={{ fontSize: '12px', color: theme.colors.textMuted, textDecoration: 'line-through' }}>
                    {formatPrice(part.original_line_total_incl_vat)}
                  </Typography>
                  <Typography sx={{ fontSize: '11px', fontWeight: '600', color: '#4caf50' }}>
                    {`\u2212${parseFloat(part.discount_percent)}%`}
                  </Typography>
                </Box>
              )}
              <Typography sx={{ fontSize: '14px', fontWeight: '600', color: theme.colors.text }}>
                {formatPrice(part.line_total_incl_vat || part.line_total || part.price)}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}

export default PartsListCard;
